import { render, staticRenderFns } from "./learning-journeys.vue?vue&type=template&id=5035053d&scoped=true&"
import script from "./learning-journeys.vue?vue&type=script&lang=js&"
export * from "./learning-journeys.vue?vue&type=script&lang=js&"
import style0 from "./learning-journeys.vue?vue&type=style&index=0&id=5035053d&lang=scss&scoped=true&"
import style1 from "./learning-journeys.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./learning-journeys.vue?vue&type=style&index=2&id=5035053d&lang=scss&scoped=true&"
import style3 from "./learning-journeys.vue?vue&type=style&index=3&id=5035053d&lang=scss&scoped=true&"
import style4 from "./learning-journeys.vue?vue&type=style&index=4&id=5035053d&lang=scss&scoped=true&"
import style5 from "./learning-journeys.vue?vue&type=style&index=5&id=5035053d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035053d",
  null
  
)

export default component.exports